module.exports = __webpack_public_path__ + "static/library-mobile-93dd6c90dd4be1c6561d0d7f0697ab56.png";